import './ModalOptions.css';

import * as cardService from "../services/cardServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'

export class ChoiceDevice extends Component {
    static displayName = ChoiceDevice.name;
    state = {
        showModal: false,


        //list: [],
    };


    componentDidMount() {
        //this.getCard();
    }

    clearData = () => {
        this.setState({ deviceName: "", deviceNumber: "" });
    }
    /*
    getCard = () => {
        let card = cardService.getCard();
         
        let choice = cardService.getChoiceCard();
        if (choice != []) {
            let article = card.find(m => m.deviceNumber === choice.deviceNumber);
            if (article) {
                console.log('find2',article);
                article.ch=true;
            }
        }

        this.setState({ list: card });
        //console.log('dd',card); 
    }*/

    componentDidUpdate(prevProps, prevState) {
        //console.log('prevProps2',prevProps);
        //console.log('prevState2',prevState);
        if (prevProps.showModal != this.state.showModal) {
            this.setState({ showModal: prevProps.showModal });
            //this.getCard();
            this.clearData();
            console.log('prevState2-----');
        }
    }

    handleChangeCard = (event, item, index) => {
        const target = event.target;
        const value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value;
        //const value = target.value;
        const name = target.name;
        let list = this.props.list;
        for (let i = 0; i < list.length; i++)
            list[i].ch = false;
        //console.log('ff1',list);
        list[index][name] = value;
        //console.log('ff2',list);
        this.props.setList(list);
    }

    doChoice = (e) => {
        e.preventDefault();
        let list = this.props.list;
        let article = list.find(m => m.ch === true);
        if (article) {
            cardService.saveChoiceCard(article);
        }
        this.props.closeModal(e)
    }

    render() {
        let listDevice = this.props.list.map((item, index) => {
            return (
                <div className="row" key={"choiseDevice" + index}>

                    <div className="col">
                        <span>{item.deviceName}</span>
                    </div>
                    <div className="col-auto">
                        <input type="radio"
                            name="ch"
                            checked={item.ch == true}
                            onChange={(e) => this.handleChangeCard(e, item, index)} />
                    </div>
                </div>
            )
        });
        return (
            <>
                <CustomModal dd="modal-sm" show={this.props.showModal} onClose={(e) => { this.props.closeModal(e) }} >
                    <div className="" >
                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-center">انتخاب دستگاه</div>
                            </div>
                        </div>
                        {listDevice}
                        <div className="row">
                            <div className="col">
                                <div className=" d-flex justify-content-center" >
                                    <button className="btn btn-dark" onClick={(e) => { this.doChoice(e) }}>انتخاب</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomModal>
            </>
        );
    }


}